import Hero from './components/Hero';
import About from './components/About';
import Procedures from './components/Procedures';
import Strategy from './components/Strategy';
import Cellulite from './components/Cellulite';
import Results from './components/Results';
import Facial from './components/Facial';
import Differentials from './components/Differentials';
import CTA from './components/CTA';
import Legal from './components/Legal';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Procedures />
      <Strategy />
      <Cellulite />
      <Results />
      <Facial />
      <Differentials />
      <CTA />
      <Legal />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
